module.exports = __webpack_public_path__ + "img/sulfur-processing.685d84bb.png";